import React, { useEffect, useState } from 'react';
import { SoundFilled, MutedOutlined, SoundOutlined } from '@ant-design/icons';
import { useNuPlayerContext } from '../NuPlayerContext';

export const VolumeControl = () => {
  const [volume, setVolume] = useState(100);
  const [muteVolume, setMuteVolume] = useState(false);
  const { audioRef } = useNuPlayerContext();

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume / 100;
      audioRef.current.muted = muteVolume;
    }
  }, [volume, audioRef, muteVolume]);

  const handleVolumeChange = (e) => {
    setVolume(Number(e.target.value));
  };

  const volumeKnobStyle = {
    background: `linear-gradient(to right, #f50 ${volume}%, #ccc ${volume}%)`,
  };

  return <div className="npVolume">
    <button onClick={() => setMuteVolume((p) => !p)}>
      { muteVolume || volume < 5 ? <MutedOutlined /> : volume < 40 ? <SoundOutlined /> : <SoundFilled /> }
    </button>
    <input type="range" min={0} max={100} value={volume} className="npVolume__knob" onChange={handleVolumeChange} style={volumeKnobStyle} />
  </div>;
};
